import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Like, Repository } from 'typeorm';
import { AppointmentEntity } from './appointment.entity';
import { AllAppointmentResponseModel, AppointmentResponseModel } from './appointment-response-module';
import { AppointmentDTO } from './dto/appointment.dto';


@Injectable()
export class AppointmentService {
    constructor (
        @InjectRepository(AppointmentEntity)
        private AppRepo: Repository<AppointmentEntity>, 
    ) {}    
    
    
    async createAppointment(queryParams,appDto:AppointmentDTO,request:Request): Promise<AppointmentResponseModel> {
        const response = new AppointmentResponseModel();
        try {
            appDto.createdUser = appDto.userId;
            if(queryParams.apiVersion == 1) {
                const saved = await this.AppRepo.save(appDto);
                const data = await this.AppRepo.findOne({
                    where:{Id:saved.Id}
                })
                if(saved) {
                    response.status = true;
                    response.data   = data;
                    response.statusCode = 50000;
                    response.internalMessage = 'Appointment saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Appointment not saved')
                }
            } else {
                const saved = await this.AppRepo.save(appDto);
                const data = await this.AppRepo.findOne({
                    where:{Id:saved.Id}
                })
                if(saved) {
                    response.status = true;
                    response.data   = data;
                    response.statusCode = 50000;
                    response.internalMessage = 'Appointment saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Appointment not saved')
                }
            }      
            return response;
        } catch (error) {
            throw error;
        }
    }
	
    async getAppointments(queryParams,userId,request:Request):Promise<AllAppointmentResponseModel> {
        const response = new AllAppointmentResponseModel();
        try {
            const finalData: any[] = [];
            if(queryParams.apiVersion == 1) {
                const data = await this.AppRepo.find({
                    relations:['user','user.profile'],
                    where: {status: true, userId:userId},
                    order: { createdAt: 'DESC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        title:b.title,
                        datetime: b.datetime,
                        purpose: b.purpose,
                        name: b.name,
                        mobile: b.mobile,
                        email: b.email,
                        location: b.location,
                        address: b.address,
                        userId: b.userId,
                        firstName:b.user.profile.firstName != null ? b.user.profile.firstName:'',
                        profilePic:b.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${b.user.profile.profilePic}` : '',
                        createdAt: b.createdAt
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }  else {
                const data = await this.AppRepo.find({
                    relations:['user','user.profile'],
                    where: {status: true, userId:userId},
                    order: { createdAt: 'DESC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        title:b.title,
                        datetime: b.datetime,
                        purpose: b.purpose,
                        name: b.name,
                        mobile: b.mobile,
                        email: b.email,
                        location: b.location,
                        address: b.address,
                        userId: b.userId,
                        firstName:b.user.profile.firstName != null ? b.user.profile.firstName:'',
                        profilePic:b.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${b.user.profile.profilePic}` : '',
                        createdAt: b.createdAt
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getAppointmentById(queryParams,Id,request:Request):Promise<AppointmentResponseModel> {
        const response = new AppointmentResponseModel();
        try {
            const finalData: any[] = [];
            if(queryParams.apiVersion == 1) {
                const data = await this.AppRepo.find({
                    relations:['user','user.profile'],
                    where: {status: true, Id:Id},
                    order: { createdAt: 'DESC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        title:b.title,
                        datetime: b.datetime,
                        purpose: b.purpose,
                        name: b.name,
                        mobile: b.mobile,
                        email: b.email,
                        location: b.location,
                        address: b.address,
                        userId: b.userId,
                        firstName:b.user.profile.firstName != null ? b.user.profile.firstName:'',
                        profilePic:b.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${b.user.profile.profilePic}` : '',
                        createdAt: b.createdAt
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }  else {
                const data = await this.AppRepo.find({
                    relations:['user','user.profile'],
                    where: {status: true, Id:Id},
                    order: { createdAt: 'DESC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        title:b.title,
                        datetime: b.datetime,
                        purpose: b.purpose,
                        name: b.name,
                        mobile: b.mobile,
                        email: b.email,
                        location: b.location,
                        address: b.address,
                        userId: b.userId,
                        firstName:b.user.profile.firstName != null ? b.user.profile.firstName:'',
                        profilePic:b.user.profile.profilePic != null ? `${process.env.WORKINGURL}/${b.user.profile.profilePic}` : '',
                        createdAt: b.createdAt
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

}
